import styled from "styled-components";
import InfoListForManagement from "./InfoListForManagement";
import ButtonsForManagement from "./ButtonsForManagement";
import MapSectionForManagement from "./MapSectionForManagement";
import { useEffect, useState } from "react";
import { serverLine } from "../../../../../controllers/network/serverLine";
import NomenclatureOfEmployee from "../../nomenclature/NomenclatureOfEmployee";
import NomenclatureOfAbsence from "../../nomenclature/NomenclatureOfAbsence";
import NomenclatureOfDispute from "../../nomenclature/NomenclatureOfDispute";
import NomenclatureOfSite from "../../nomenclature/NomenclatureOfSite";
import NomenclatureOfComment from "../../nomenclature/NomenclatureOfComment";
import NomenclatureOfVacation from "../../nomenclature/NomenclatureOfVacation";
import InfoListForManagementGridView from "./InfoListForManagementGridView";
import PermissionGuard from "../../../../customUiForCs/PermissionGuard";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

const Section = styled.div`
  display: flex;
  flex-direction: row;
  /* align-items: flex-start; */
  gap: 20px;
  width: 100%;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
`;

const ColumnSection = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 10px;
`;

const MainRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 10px;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

export default function SectionsForManagement() {
  const [data, setData] = useState(null);

  useEffect(() => {
    serverLine.get("/dashboard").then(setData);
  }, []);

  return (
    <Container>
      <Section>
        <Column>
          <MapSectionForManagement />
          <ButtonsForManagement />
        </Column>

        {/* <InfoListForManagement data={data} /> */}

        <InfoListForManagementGridView data={data} />
      </Section>

      <MainRow>
        <ColumnSection>
          <NomenclatureOfEmployee />
          <NomenclatureOfAbsence />
          {/* <NomenclatureOfDispute /> */}
        </ColumnSection>
        <ColumnSection>
          <NomenclatureOfSite />
          <NomenclatureOfComment />
          <NomenclatureOfVacation onlyForThisMonth={true} />
        </ColumnSection>
      </MainRow>
    </Container>
  );
}
